define('collections/questionnaire/responses',[
    'underscore',
    'backbone',
    'utils',
    // services
    'services/api',
    // parent
    'src/plugins/infinite-collection',
    // models
    'models/questionnaire/response'
], function(
    _, Backbone, U,
    // services
    API,
    // parent
    InfiniteCollection,
    // models
    MResponse
) {

    var CResponses = InfiniteCollection.extend({
        model: MResponse,
        state: {
            pageSize: 50,
        },
        url: function() {
            var url = 'questionnaires/r/';

            if (this.questionnaire) {
                url = 'questionnaires/q/' + this.questionnaire.id + '/';
            }

            if (this.options.user) {
                url = 'users/me/questionnaires/';
            }

            return API.url(url);
        },

        parse: function(data, opt) {
            if (data._users) {
                this._users = data._users;
                this.setResponseUser(data);
            }
            return CResponses.__super__.parse.call(this, data);
        },

        initialize: function(models, opt) {
            this.options = opt || {};
            this.setQuestionnaire(opt.questionnaire);

            return CResponses.__super__.initialize.call(this, models, opt);
        },

        _prepareModel: function(attrs, options) {
            attrs = _.extend({}, attrs, { _questionnaire: this.questionnaire });

            return CResponses.__super__._prepareModel.call(this, attrs, options);
        },

        setResponseUser: function(data) {
            _.each(data.collection, function(responseObj) {
                responseObj._user = data._users[responseObj.user];
            }, this);
        },

        findByUserId: function(userId) {
            return this.findWhere({ user: userId });
        },

        setQuestionnaire: function(questionnaire) {
            if (!this.questionnaire) {
                this.questionnaire = questionnaire;
            }
        },

    });

    return CResponses;

});

